<template>
    <component :is="component"
               :href="href"
               :to="to"
               class="wb-link"
               :class="classes"
               @click="handleClick"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
    import type { WBLinkEmits, WBLinkProps } from '~/src/shared/components/ui/link/types'

    const props = withDefaults(defineProps<WBLinkProps>(), {
        color: 'blue',
    })

    const emits = defineEmits<WBLinkEmits>()

    const component = computed(() => {
        if (props.to) {
            return resolveComponent('nuxt-link')
        }

        if (props.tag) {
            return props.tag
        }

        return 'a'
    })

    const classes = computed(() => ({
        _dashed: props.dashed,
        [`_${props.color}`]: props.color,
        [props.size]: props.size,
    }))

    const handleClick = (e: Event) => {
        emits('click', e)
    }
</script>

<style lang="scss" scoped>
    .wb-link {
        display: inline-flex;
        cursor: pointer;

        &._dashed {
            position: relative;

            &:after {
                content: "";
                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: currentcolor;
            }
        }

        &._blue {
            color: var(--blue-800);
        }

        &._black {
            color: var(--black-color);

            @include hover {
                color: var(--blue-600);
            }
        }

        &._grey {
            color: var(--grey-500);

            @include hover {
                color: var(--blue-600);
            }
        }

        &._current {
            color: inherit;
        }
    }
</style>
